import { FC } from 'react';
import { Button, Form, Modal } from 'antd';
import { yupSync } from '../../utils';
import close from '../../assets/RoundedClose.svg';
import * as Yup from 'yup';
import { FloatTextArea } from '../../components/Fields/FloatTextArea';

interface ModalProps {
    openModal: boolean;
    setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
    requestWithdraw: (data: string) => void;
}

const validationSchema = Yup.object().shape({
    comment: Yup.string()
        .required('This is a required field')
        .test('comment', 'This is a required field', (value) => {
            const passwordRegex = /[^\s]/;
            return passwordRegex.test(value);
        })
});

export const WithdrawModal: FC<ModalProps> = ({ openModal, setOpenModal, requestWithdraw }) => {
    const [form] = Form.useForm();

    const handleFormSubmit = () => {
        form.validateFields()
            .then((values: any) => {
                requestWithdraw(values.comment);
            })
            .catch((err) => console.log('err', err));
    };

    return (
        <>
            <Modal
                className="modal-modal"
                destroyOnClose
                centered
                open={openModal}
                onOk={() => handleFormSubmit()}
                onCancel={() => {
                    setOpenModal(false);
                }}
                closeIcon={<img src={close} />}
                footer={
                    <div style={{ display: 'flex', justifyItems: 'space-between', gap: '16px', width: '100%' }}>
                        <Button
                            block
                            key="back"
                            onClick={() => {
                                setOpenModal(false);
                            }}
                            className="cancel"
                        >
                            Cancel
                        </Button>
                        <Button
                            block
                            key="submit"
                            type="primary"
                            onClick={() => {
                                handleFormSubmit();
                            }}
                        >
                            Save
                        </Button>
                    </div>
                }
            >
                <div className="modal">
                    <div className="modal__header meeting" style={{ height: '88px' }}>
                        <div className="modal__title">Withdraw from Process</div>
                    </div>

                    <div className="modal__main main" style={{ padding: '24px 56px 43px 56px' }}>
                        <Form form={form} onFinish={handleFormSubmit}>
                            <Form.Item name="comment" rules={yupSync('comment', validationSchema, true)}>
                                <FloatTextArea
                                    required={true}
                                    maxLength={512}
                                    floatLabel={'Reason for Withdrawal'}
                                    onChange={() => {}}
                                    hasError={() => !!form.getFieldError(['comment']).length}
                                    type="common"
                                />
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </Modal>
        </>
    );
};
